export const GET_CURRENT_HOST_PROFILE = 'GET_CURRENT_HOST_PROFILE'
export const GET_HOST_MISSIONS = 'GET_HOST_MISSIONS'
export const DELETE_MISSION = 'DELETE_MISSION'
export const GET_CURRENT_HOST_BALANCE = 'GET_CURRENT_HOST_BALANCE'
export const GET_PAYMENT_REQUESTS = 'GET_PAYMENT_REQUESTS'
